export const ColumnIds = {
  name: 'name',
  displayOrder: 'displayOrder',
  code: 'code',
  isInviting: 'isInviting',
  isDeactivated: 'isDeactivated'
} as const;